import React from "react";
import { Tabs } from "@mui/material";
import { Theme } from "@mui/material/styles";

import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme: Theme) => ({
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
    minHeight: 500,
    "& .MuiTab-wrapper": {
      textAlign: "left",
      alignItems: "start",
      marginLeft: 5,
    },
    "& .MuiTab-root": {
      textAlign: "left !important",
      minHeight: "38px",
      alignItems: "flex-start",
      justifyContent: "flex-start",
    },
  },
  indicator: {
    "&.MuiTabs-indicator": {
      left: 0,
      width: 5,
      backgroundColor: theme.palette.secondary.main,
    },
  },
}));
interface Props {
  handleChange: any;
  value: string | number;
  tabMinHeight?: number;
  minHeight?: number;
  children: any;
}

export default function CommonTabs({
  handleChange,
  value,
  tabMinHeight,
  children,
  minHeight,
}: Props) {
  const classes = useStyles();
  return (
    <>
      <Tabs
        orientation="vertical"
        variant="scrollable"
        scrollButtons="auto"
        value={value}
        onChange={handleChange}
        className={classes.tabs}
        selectionFollowsFocus
        classes={{ indicator: classes.indicator }}
        style={{ height: tabMinHeight || "inherit", minHeight: minHeight || 500 }}
      >
        {children}
      </Tabs>
    </>
  );
}
